import Vue from "vue";
import Vuetify, {
  VApp, // required
  VNavigationDrawer,
  VFadeTransition,
  VLayout,
  VCard,
  VCardTitle,
  VCardText,
  VCardActions,
  VSheet,
} from "vuetify/lib";
import { Ripple } from "vuetify/lib/directives";
import colors from "vuetify/es5/util/colors";

Vue.use(Vuetify);

const opts = {
  components: {
    VApp,
    VNavigationDrawer,
    VFadeTransition,
    VLayout,
    VCard,
    VCardTitle,
    VCardText,
    VCardActions,
    VSheet,
  },

  directives: {
    Ripple,
  },

  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#6200EE",
        secondary: "#15B9A6",
        accent: "#f34747",
      },
      dark: {
        accent: "#6200EE",
        secondary: "#15B9A6",
        primary: "#f34747",
      },
    },
  },

  //https://materialdesignicons.com/
  icons: {
    iconfont: "mdi", // default
    values: {
      customers: "mdi-card-account-details-outline",
      leads: "mdi-account-arrow-right-outline",
      campaigns: "mdi-facebook",
      checkins: "mdi-timer-sand",
      survey: "mdi-file-document-check-outline",
      checkins_vehicle: "mdi-car-clock",
      checkins_property: "mdi-home-clock",
      checkins_policy: "mdi-clipboard-text-clock-outline",
      rewards: "mdi-trophy-variant-outline",
      payouts: "mdi-currency-usd",
      payout: "mdi-currency-usd",
      car: "mdi-car-back",
      camera: "mdi-camera",
      camera_take: "mdi-camera-plus",
      camera_retake: "mdi-camera-retake-outline",
      home: "mdi-google-home",
      dashboard: "mdi-cellphone-link",
      insurance: "mdi-shield-car",
      databuyer: "mdi-database-eye-outline",
      report: "mdi-chart-areaspline",
      export: "mdi-database-export-outline",
      import: "mdi-database-import-outline",
      refresh: "mdi-refresh",
      upload: "mdi-cloud-upload-outline",
      download: "mdi-cloud-download-outline",
      vehicle: "mdi-car",
      reports: "mdi-file-table-outline",
      user: "mdi-account-circle-outline",
      settings: "mdi-settings-outline",
      close: "mdi-close-circle-outline",
      color: "mdi-palette",
      more: "mdi-dots-vertical",
      back: "mdi-arrow-left",
      print: "mdi-printer-wireless",
      copy: "mdi-content-copy",
      pdf: "mdi-file-pdf",
      xsl: "mdi-file-excel",
      photo: "mdi-file-image",
      login: "mdi-fingerprint",
      logout: "mdi-fingerprint-off",
      continue: "mdi-play-circle-outline",
      camera: "mdi-camera",
      search: "mdi-magnify",
      edit: "mdi-circle-edit-outline",
      play: "mdi-motion-play-outline",
      send: "mdi-send",
      sync: "mdi-autorenew",
      sync_cloud: "mdi-cloud-sync-outline",
      sync_db: "mdi-database-sync",
      address: "mdi-map-search-outline",
      map: "mdi-google-maps",
      email: "mdi-at",
      password: "mdi-lock-question",
      phone: "mdi-cellphone-android",
      odometer: "mdi-gauge",
      reward: "mdi-trophy-variant-outline",
      required: "mdi-asterisk",
      install: "mdi-progress-download",
      update: "mdi-sync", //"mdi-cellphone-arrow-down",
      remove: "mdi-delete-empty-outline",
      add: "mdi-plus",
      add_calendar: "mdi-calendar-plus",
      date: "mdi-calendar",
      correct: "mdi-check-all",
      correct_info: "mdi-check",
      incorrect: "mdi-close",
      stop: "mdi-minus",
      addcheckin: "mdi-plus",
      deactivate: "mdi-stop",
      activate: "mdi-check",

      mini_mode: "mdi-arrow-expand",
      dark_mode: "mdi-battery-charging-100",
      bright_mode: "mdi-battery-charging-30",

      notifications_on: "mdi-bell-ring-outline",
      notifications_off: "mdi-bell-outline",

      network_on: "mdi-wifi", //'mdi-access-point-network',
      network_off: "mdi-wifi-off", //'mdi-access-point-network-off'
      network_warn: "mdi-wifi-strength-alert-outline", //'mdi-access-point-network-off'

      microsoft: "mdi-microsoft",
      microsoft_office: "mdi-microsoft-office",
      microsoft_outlook: "mdi-microsoft-outlook",
      ics: "mdi-calendar-clock",
      google: "mdi-google",
      android: "mdi-android",
      apple: "mdi-apple",
      facebook: "mdi-facebook",
      amazon: "mdi-amazon",
      yahoo: "mdi-yahoo",
    },
  },
};

export default new Vuetify(opts);
